module.exports = __webpack_public_path__ + "78b370e36ba3e7551dfb73c8aa9797ea.jpg";